import { createContext, type PropsWithChildren } from "react";
import useLoadingBackdropOverlay from "./useLoadingBackdropOverlay";

export const LoadingBackdropOverlayContext = createContext({} as ReturnType<typeof useLoadingBackdropOverlay>);

const LoadingBackdropOverlayProvider = ({ children }: PropsWithChildren) => (
    <LoadingBackdropOverlayContext.Provider
        value={useLoadingBackdropOverlay()}
    >
        {children}
    </LoadingBackdropOverlayContext.Provider>
);

export default LoadingBackdropOverlayProvider;
